<div class="container-fluid">
  <table
    mat-table
    #tabla
    [dataSource]="modelTransformed"
    class="mat-elevation-z8 table-striped"
  >
    <ng-container matColumnDef="AreaZonaCuadrante">
      <th mat-header-cell *matHeaderCellDef>Area-ZonaCuadrante</th>
      <td mat-cell *matCellDef="let inspeccion">
        {{ inspeccion.AreaZonaCuadrante }}
      </td>
      <ng-container matColumnDef="Tipo">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let inspeccion">{{ inspeccion.Tipo }}</td>
      </ng-container>
      <ng-container matColumnDef="Severidad">
        <th mat-header-cell *matHeaderCellDef>Severidad</th>
        <td mat-cell *matCellDef="let inspeccion">
          {{ inspeccion.Severidad }}
        </td>
      </ng-container>
    </ng-container>
    <ng-container matColumnDef="Observacion">
      <th mat-header-cell *matHeaderCellDef>Observacion</th>
      <td mat-cell *matCellDef="let inspeccion">
        {{ inspeccion.Observacion }}
      </td>
    </ng-container>
    <ng-container matColumnDef="Responsable">
      <th mat-header-cell *matHeaderCellDef>Responsable</th>
      <td mat-cell *matCellDef="let inspeccion">
        {{ inspeccion.Responsable }}
      </td>
    </ng-container>
    <ng-container matColumnDef="Clasificacion">
      <th mat-header-cell *matHeaderCellDef>Clasificacion</th>
      <td mat-cell *matCellDef="let inspeccion">
        {{ inspeccion.Clasificacion }}
      </td>
    </ng-container>
    <ng-container matColumnDef="Codificacion">
      <th mat-header-cell *matHeaderCellDef>Codificacion</th>
      <td mat-cell *matCellDef="let inspeccion">
        {{ inspeccion.Codificacion }}
      </td>
    </ng-container>
    <tr mat-header-row [@rowsAnimation]="" *matHeaderRowDef="columnsDef"></tr>
    <tr
      mat-row
      [@rowsAnimation]=""
      *matRowDef="let row; columns: columnsDef"
    ></tr>
  </table>
</div>
